/**
 * Stockage des jetons.
 *
 * ============================================================================
 * COMPROMIS DE DÉMONSTRATION, ASSUMÉ ET DOCUMENTÉ.
 *
 * L'access token vit **en mémoire** : il disparaît à la fermeture de l'onglet,
 * et aucun script tiers ne peut le lire dans `localStorage`.
 *
 * Le refresh token, lui, est en `localStorage` — sinon toute session serait
 * perdue au moindre rechargement de page, ce qui rend la démonstration
 * pénible. C'est une **exposition réelle au XSS** : un script injecté peut le
 * lire et obtenir des sessions de 30 jours.
 *
 * Le vrai correctif n'est pas côté front : c'est un cookie `httpOnly`,
 * `SameSite=Strict`, `Secure`, posé par le backend, qu'aucun JavaScript ne
 * peut lire. Il demande une évolution des routes `/auth/*` — hors zone du lot
 * F. C'est signalé dans `docs/LOT-F-RAPPORT.md`.
 * ============================================================================
 */

const CLE_REFRESH = 'soinslib.refresh_token'

let accessToken: string | null = null

export function lireAccessToken(): string | null {
  return accessToken
}

export function poserAccessToken(jeton: string | null): void {
  accessToken = jeton
}

export function lireRefreshToken(): string | null {
  try {
    return window.localStorage.getItem(CLE_REFRESH)
  } catch {
    // Navigation privée stricte, stockage désactivé : on dégrade en session
    // non persistante plutôt que de faire tomber l'application.
    return null
  }
}

export function poserRefreshToken(jeton: string | null): void {
  try {
    if (jeton === null) window.localStorage.removeItem(CLE_REFRESH)
    else window.localStorage.setItem(CLE_REFRESH, jeton)
  } catch {
    /* stockage indisponible : la session ne survivra pas au rechargement */
  }
}

/** Efface tout. Appelée dès qu'une session devient irrécupérable. */
export function purgerJetons(): void {
  accessToken = null
  poserRefreshToken(null)
}
